import * as amplitude from "@amplitude/analytics-react-native"
import { theme } from "@common/theme/theme"
import React, { useContext } from "react"
import { StyleSheet } from "react-native"
import { Button } from "react-native-paper"
import { DimensionsContext, IS_WEB } from "../../utils/mobileUtils"
import withPreventDoubleClick from "../../utils/withPreventDoubleClick"

// react-native-paper tronque le libellé de son Button sans recours : le `Text`
// interne est câblé en `numberOfLines={1}`, ni surchargeable par une prop ni
// contournable par un style. Un libellé trop long ne déborde pas, il disparaît
// en « MODI… », silencieusement — rien ne le signale au build ni aux tests.
//
// Deux impasses en découlent, et une seule des deux se replie :
//
//   - une PHRASE trop longue peut passer à la ligne → `wrapText` ;
//   - un MOT trop long ne se coupe pas. La seule place récupérable est alors la
//     réserve de 16 px que paper pose de chaque côté du libellé → `tightLabel`.
//     Cette réserve est taillée pour SON bouton par défaut — pleine largeur,
//     50 px de haut, libellé 14 px. Un bouton compact dont la largeur est
//     imposée par un `flex` en hérite sans l'avoir : sur 105 px de bouton, 32 px
//     de réserve et 20 px de gouttière d'icône ne laissent que 53 px à
//     « MODIFIER », qui en réclame 72.
//
// Les deux props sont opt-in : relâcher la réserve pour tout le monde ferait
// tenir sur une ligne des libellés qui se replient aujourd'hui, et bougerait la
// hauteur d'écrans qui n'ont rien demandé.
const FilledButtonM = (props) => {
    const {
        mode,
        label,
        fontWeight,
        color,
        trackingId,
        onPress,
        loading,
        disabled,
        icon,
        wrapText,
        tightLabel,
    } = props
    const dimensions = useContext(DimensionsContext)

    const styles = StyleSheet.create({
        button: {
            marginBottom: 10,
            borderRadius: 15,
            width:
                dimensions?.width < 800
                    ? dimensions?.width - 40
                    : dimensions?.width / 2,
            alignSelf: "center",
            justifyContent: "center",
        },
        text: {
            fontFamily: "Montserrat-" + (fontWeight ?? "ExtraBold"),
            fontSize: 15,
            textWrap: wrapText && "wrap",
            // 8 px, la valeur que paper applique lui-même à ses boutons
            // `compact` — et non zéro : quand le libellé tient, l'écart visible
            // vient du centrage du contenu, pas de cette réserve, et la réduire
            // ne se voit donc pas. Elle ne se voit QUE sur un bouton à l'étroit,
            // où elle est précisément ce qui tronque.
            ...(tightLabel && { marginHorizontal: 8 }),
        },
        content: {
            height: 50,
        },
    })

    return (
        <Button
            textColor={
                !mode || mode === "contained" ? theme.colors.white : color
            }
            buttonColor={
                !mode || mode === "contained" ? color : theme.colors.transparent
            }
            {...props}
            uppercase={true}
            mode={mode ?? "contained"}
            loading={loading}
            disabled={disabled || loading}
            onPress={(e) => {
                onPress(e)
                if (trackingId) {
                    amplitude.track("button.clicked." + trackingId)
                }
            }}
            icon={icon}
            contentStyle={{ ...styles.content, ...props.contentStyle }}
            style={{ ...styles.button, ...props.style, elevation: 0 }}
            labelStyle={{
                ...styles.text,
                ...props.labelStyle,
                textDecorationLine: mode === "text" ? "underline" : null,
                marginVertical:
                    !IS_WEB && props.contentStyle?.height
                        ? props.contentStyle?.height / 8
                        : null,
            }}
        >
            {label}
        </Button>
    )
}

export default withPreventDoubleClick(FilledButtonM)
